import * as workroomService from 'Frontend/scripts/services/workrooms.service'
import { createContext, useContext, useState, ReactNode, useEffect } from 'react'
import { IWorkrooms } from 'Frontend/scripts/models/workrooms.model'

interface ManageWorkroomsContextType {
  workrooms: IWorkrooms | null
  isLoading: boolean
  getAllWorkrooms: (pageIndex?: number) => void
}

const ManageWorkroomsContext = createContext<ManageWorkroomsContextType | undefined>(undefined)

export const ManageWorkroomsProvider = ({ children }: { children: ReactNode }) => {
  const [workrooms, setWorkrooms] = useState<IWorkrooms | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const getAllWorkrooms = (pageIndex?: number) => {
    setIsLoading(true)
    workroomService.getAllWorkrooms(pageIndex).then((workrooms) => {
      setWorkrooms(workrooms)
      setIsLoading(false)
    })
  }

  useEffect(() => {
    getAllWorkrooms()
  }, [])

  return (
    <ManageWorkroomsContext.Provider
      value={{
        workrooms,
        isLoading,
        getAllWorkrooms,
      }}
    >
      {children}
    </ManageWorkroomsContext.Provider>
  )
}

export const useManageWorkroomsContext = () => {
  const context = useContext(ManageWorkroomsContext)
  if (!context) {
    throw new Error('useManageWorkroomsContext must be used within a ManageWorkroomsContext')
  }
  return context
}
